import { EMPTY_OBJECT } from '../constants';
import config from '../config';

const ignoredMessages = ['Not a Product'];
const rollbarAccessToken = config.analytics.rollbarAccessToken;
let RollbarInstance;

export function bootstrapRollbar(rollbar) {
  if (!rollbarAccessToken) {
    return;
  }

  RollbarInstance = new rollbar({
    accessToken: rollbarAccessToken,
    captureUncaught: true,
    captureUnhandledRejections: true,
    autoInstrument: true,
    ignoredMessages: ignoredMessages,
    payload: {
      environment: process.env.NODE_ENV,
    },
  });
}

export default {
  global: function(options = EMPTY_OBJECT) {
    if (!RollbarInstance) {
      return;
    }
    RollbarInstance.global(options);
  },
  configure: function(options = EMPTY_OBJECT) {
    if (!RollbarInstance) {
      return;
    }
    RollbarInstance.configure(options);
  },
  debug: function(item) {
    if (!RollbarInstance) {
      return;
    }
    RollbarInstance.debug(item);
  },
  info: function(item) {
    if (!RollbarInstance) {
      return;
    }
    RollbarInstance.info(item);
  },
  warn: function(item) {
    if (!RollbarInstance) {
      return;
    }
    RollbarInstance.warn(item);
  },
  warning: function(item) {
    if (!RollbarInstance) {
      return;
    }
    RollbarInstance.warning(item);
  },
  error: function(item) {
    if (!RollbarInstance) {
      return;
    }
    RollbarInstance.error(item);
  },
  critical: function(item) {
    if (!RollbarInstance) {
      return;
    }
    RollbarInstance.critical(item);
  },
};



// WEBPACK FOOTER //
// ./src/lib/rollbar.js